import { CartRule } from 'cart-rule';
class CartRuleEngine {
	constructor({ rules = [], options = {}, successMessage }) {
		const defaultOptions = {
			removeUnqualifiedGift: true,
		};
		this.options = {
			...defaultOptions,
			...options,
		};
		this.successMessage = successMessage;
		this.rules = rules.map((rule) => new CartRule(rule));
		this.initRulePositions();
	}
	initRulePositions() {
		this.rules
			.sort((a, b) => {
				return a.threshold - b.threshold;
			})
			.forEach((rule, index) => {
				rule.position = (index + 1) / (this.rules.length + 1);
			});
	}
	getQualifiedRules(cart) {
		const discountedPricePerOrder = cart.cart_level_discount_applications.reduce((total, app) => {
			return total + (app.total_allocated_amount || 0);
		}, 0);
		return this.rules
			.filter((rule) => rule.isRuleQualified({ cartTotal: cart.total_price, discountedPricePerOrder }))
			.sort((a, b) => {
				return a.threshold - b.threshold;
			});
	}

	getUnqualifiedRules(cart) {
		const discountedPricePerOrder = cart.cart_level_discount_applications.reduce((total, app) => {
			return total + (app.total_allocated_amount || 0);
		}, 0);
		return this.rules
			.filter((rule) => !rule.isRuleQualified({ cartTotal: cart.total_price, discountedPricePerOrder }))
			.sort((a, b) => {
				return a.threshold - b.threshold;
			});
	}
	getShippingPrice(cart) {
		const shippingRule = this.rules.find((rule) => rule.ruleType === 'GIFT_BAR_ITEM_SHIPPING');
		if (shippingRule) {
			return shippingRule.getShippingPrice({ cartTotal: cart.total_price });
		}
		return null;
	}
	getFormattedText(cart) {
		const unqualifiedRules = this.getUnqualifiedRules(cart);
		if (unqualifiedRules.length > 0) {
			const nextRule = unqualifiedRules[0];
			return nextRule.getFormattedRemainingText({ cartTotal: cart.total_price });
		}
		return this.successMessage;
	}
	getPayloadsRules(cart) {
		return this.options.removeUnqualifiedGift ? this.rules : this.getQualifiedRules(cart);
	}
	processCartRules(cart) {
		const removedItemIds = this.getRemovedItemIDs(cart);
		const qualifiedRules = this.getQualifiedRules(cart);
		const payloads = this.getPayloadsRules(cart)
			.filter((rule) => !rule.isRuleGiftRemoved(removedItemIds))
			.map((rule) =>
				rule.getUpdatePayload({
					cartTotal: cart.total_price,
					lineItems: cart.items,
				}),
			)
			.filter((payload) => payload !== null);
		return {
			qualifiedRules,
			payloads,
			formattedText: this.getFormattedText(cart),
			shippingPrice: this.getShippingPrice(cart),
			cartBarProgress: this.getCartBarProgress(cart),
		};
	}
	getCartBarProgress(cart) {
		const totalPrice = cart.total_price;
		const qualifiedRules = this.getQualifiedRules(cart);
		const unqualifiedRules = this.getUnqualifiedRules(cart);
		const startRule = qualifiedRules.pop();
		const endRule = unqualifiedRules.shift();
		if (!endRule) {
			// all rules are qualified
			return 100;
		}
		const startThreshold = startRule?.threshold || 0;
		const endThreshold = endRule?.threshold || 100;
		const startPosition = startRule?.position * 100 || 0;
		const endPosition = endRule?.position * 100 || 100;
		const progressBetweenBothPositions = (totalPrice - startThreshold) / (endThreshold - startThreshold);
		const progress = startPosition + progressBetweenBothPositions * (endPosition - startPosition);
		return progress;
	}
	getRulePositions() {
		return this.rules.map((rule) => ({
			ruleID: rule.ruleID,
			position: rule.position,
		}));
	}
	getRemovedItemIDs(cart) {
		return cart?.items_removed?.map((item) => item.variant_id) || [];
	}
}
export { CartRuleEngine };
